import React, { useEffect, useMemo } from "react";
import { UserFeedsType } from "../../types";

type UserActivityReaderProps = {
  onOpen?: () => void;
  userFeed: UserFeedsType | undefined;
  user: any;
  createLikeLoading: boolean;
  deleteLikeLoading: boolean;
  showDetailedLikes: boolean;
  setShowDetailedLikes: React.Dispatch<React.SetStateAction<boolean>>;
};
const UserActivityReader: React.FC<UserActivityReaderProps> = ({
  userFeed,
  onOpen,
  user,
  deleteLikeLoading,
  createLikeLoading,
  setShowDetailedLikes,
  showDetailedLikes,
}) => {
  // console.log(feedLike?.feedLikes, 'feedLikes');
  // console.log(userFeed?.id, 'feedLikes');

  const specificUserLike = userFeed?.feedLikes?.find(
    (a) => a.likedBy.id === user.id
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDetailedLikes(true);
    }, 600000); // 10 minutes

    return () => clearTimeout(timer); // Clean up the timer when the component unmounts
  }, [setShowDetailedLikes]);

  const likes = useMemo(() => {
    return userFeed?.feedLikes
      ?.slice(0, 2)
      .map((a) => {
        const fullName = `${a.likedBy.firstName} ${a.likedBy.lastName}`;
        return a === specificUserLike ? " You " : fullName;
      })
      .join(" and ");
  }, [userFeed, specificUserLike]);

  const totalLikes = userFeed?.feedLikes?.length || 0;

  return (
    <div className="w-full flex justify-between absolute h-5 lg:bottom-[60px] bottom-[57px] text-[#646464] font-Poppins text-[8px] mx-auto lg:text-[14.7px] lg:font-SegoeUI font-normal lg:px-4">
      <div className="flex text-searchCol w-[64%]">
        {createLikeLoading || deleteLikeLoading ? (
          <div className="flex">
            <p>
              {deleteLikeLoading
                ? totalLikes > 1
                  ? `${totalLikes - 1} like${totalLikes > 1 ? "s" : ""} `
                  : totalLikes === 0 && ""
                : createLikeLoading && `${totalLikes + 1} like${totalLikes > 1 ? "s" : ""}`}
            </p>
          </div>
        ) : (
          userFeed?.id &&
          userFeed &&
          userFeed?.feedLikes?.length > 0 && (
            <div className="flex">
              {showDetailedLikes ? (
                userFeed && userFeed?.feedLikes?.length < 3 ? (
                  <p>Liked by {likes}</p>
                ) : (
                  <p>
                    {specificUserLike
                      ? `You and ${totalLikes - 1} others`
                      : `${totalLikes} likes`}
                  </p>
                )
              ) : (
                <p>{`${totalLikes} like${totalLikes > 1 ? "s" : ""}`}</p>
              )}
            </div>
          )
        )}
      </div>
      <div className="flex gap-1 w-[35%] justify-end text-searchCol">
        {userFeed?.comments ? (
          userFeed?.comments && userFeed?.comments.length === 1 ? (
            <div className="flex gap-1">
              <div className="flex cursor-pointer" onClick={onOpen}>
                View comment
              </div>
              {/* <PiDotBold size={20} className='fill-searchCol'/> */}
            </div>
          ) : (
            userFeed?.comments.length > 1 && (
              <div className="flex gap-1">
                <div className="flex cursor-pointer" onClick={onOpen}>
                  View all {userFeed?.comments?.length} comments
                </div>
                {/* <PiDotBold size={20} className='fill-searchCol'/> */}
              </div>
            )
          )
        ) : null}
        {/* <div className="flex justify-end">
          {shares} shares
        </div> */}
      </div>
    </div>
  );
};

export default UserActivityReader;
